import { isApplicationLocked } from './helperV2';

const ALL = '*';

export const getLockState = (applicationForm, jsonConfig = {}) => {
    const locked = isApplicationLocked(applicationForm, jsonConfig);
    const configured = jsonConfig?.lockRules?.readOnlyFieldsWhenLocked;
    const readOnlyFields = Array.isArray(configured) ? configured : [];
    const readOnlyAll = locked && readOnlyFields.includes(ALL);

    return {
        locked,
        readOnlyAll,
        readOnlyFields,
        isFieldReadOnly: (fieldName) => {
            if (!locked) return false;
            if (readOnlyAll) return true;
            return readOnlyFields.includes(fieldName);
        },
    };
};

export default getLockState;

